export const hubspot = {
  namespaced: true,

  state: {
    openDeals: [],
    loading: false,
    error: null,
    lastFetched: null
  },

  getters: {
    openDeals: state => state.openDeals,
    loading: state => state.loading,
    error: state => state.error,
    lastFetched: state => state.lastFetched,
    // Get deal by ID for pre-selection
    getDealById: state => (id) => state.openDeals.find(deal => deal.id === id)
  },

  mutations: {
    SET_OPEN_DEALS(state, deals) {
      state.openDeals = deals
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_LAST_FETCHED(state, timestamp) {
      state.lastFetched = timestamp
    },
    CLEAR_DEALS(state) {
      state.openDeals = []
      state.lastFetched = null
    }
  },

  actions: {
    setOpenDeals({ commit }, deals) {
      commit('SET_OPEN_DEALS', deals)
      commit('SET_LAST_FETCHED', Date.now())
    },
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setError({ commit }, error) {
      commit('SET_ERROR', error)
    },
    clearDeals({ commit }) {
      commit('CLEAR_DEALS')
    }
  }
}
